(() => {
  if (window.__ss26GolfPerformanceTabsInitialised) return;
  window.__ss26GolfPerformanceTabsInitialised = true;

  const activateTab = (root, nextTab, moveFocus = false) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    const targetId = nextTab.getAttribute('aria-controls');

    tabs.forEach((tab) => {
      const isActive = tab === nextTab;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      tab.classList.toggle('is-active', isActive);
    });

    panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    if (moveFocus) nextTab.focus();
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-ss26-performance-tab]');
    if (!tab) return;
    const root = tab.closest('[data-ss26-performance-tabs]');
    if (!root) return;
    activateTab(root, tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-ss26-performance-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const root = tab.closest('[data-ss26-performance-tabs]');
    if (!root) return;

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    event.preventDefault();
    activateTab(root, tabs[nextIndex], true);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-ss26-performance-panel]');
    if (!panel) return;
    const root = panel.closest('[data-ss26-performance-tabs]');
    const tab = root?.querySelector(`[aria-controls="${panel.id}"]`);
    if (root && tab) activateTab(root, tab);
  });
})();
